import React, { useRef, useState, useEffect } from "react";
import SENShareModal from "./SENShareModal";

const SENShareActionCard = ({
  cardPosition,
  handleCloseCard,
  students, // Pass SEN Watchlist students
  className,
  teacherId,
  schoolId,
  expandedViewData, // Receive detailed data for sharing
}) => {
  const shareCardRef = useRef(null);

  const [showShareModal, setShowShareModal] = useState(false);
  const [internalStudents, setInternalStudents] = useState([]); // Internal state for students
  const [searchQuery, setSearchQuery] = useState(""); // Search query
  const [selectedStudentIds, setSelectedStudentIds] = useState([]); // Selected students
  const [selectAll, setSelectAll] = useState(false); // Select all toggle

  useEffect(() => {
    if (students && students.length > 0) {
      setInternalStudents(students); // Initialize internal students
    }
  }, [students]);

  const handleSearchChange = (e) => {
    setSearchQuery(e.target.value);
  };

  const handleStudentSelect = (studentId) => {
    setSelectedStudentIds((prevSelected) =>
      prevSelected.includes(studentId)
        ? prevSelected.filter((id) => id !== studentId)
        : [...prevSelected, studentId]
    );
    setSearchQuery(""); // Clear the search query after selection
  };

  const handleSelectAll = () => {
    if (selectAll) {
      setSelectedStudentIds([]);
    } else {
      setSelectedStudentIds(internalStudents.map((student) => student.id));
    }
    setSelectAll(!selectAll);
  };

  const filteredStudents = internalStudents.filter((student) =>
    student.name.toLowerCase().includes(searchQuery.toLowerCase())
  );

  const handleShare = () => {
    setShowShareModal(true);
  };

  return (
    <>
      <div
        ref={shareCardRef}
        className="action-card"
        style={{
          position: "absolute",
          top: `${cardPosition.top}px`,
          left: `${cardPosition.left}px`,
          zIndex: 1000,
          width: "320px",
        }}
      >
        <div className="action-card-header">
          <p className="action-header">Share</p>
          <button onClick={handleCloseCard} className="close-button">
            ✕
          </button>
        </div>

        <div className="action-card-body">
          <p className="action-body-text">Share SEN Watchlist</p>
          <div className="action-search-bar">
            <img
              src={process.env.PUBLIC_URL + "/assets/imgs/search-outline.svg"}
              alt="Search"
              className="search-icon"
            />
            <input
              type="text"
              placeholder="Search student"
              value={searchQuery}
              onChange={handleSearchChange}
              style={{
                border: "none",
                outline: "none",
                width: "100%",
                background: "transparent",
              }}
            />
          </div>

          {searchQuery && (
            <div className="search-results">
              {filteredStudents.map((student) => (
                <div
                  key={student.id}
                  className="search-result-item"
                  onClick={() => handleStudentSelect(student.id)}
                  style={{
                    backgroundColor: selectedStudentIds.includes(student.id)
                      ? "#e0e0e0"
                      : "transparent",
                  }}
                >
                  {student.name}
                </div>
              ))}
            </div>
          )}
          <div className="select-all-container">
            <input
              type="checkbox"
              id="selectAll"
              name="selectAll"
              checked={selectAll}
              onChange={handleSelectAll}
            />
            <label htmlFor="selectAll">Select All Students</label>
          </div>
          {selectedStudentIds.length > 0 && (
            <div className="selected-students">
              {selectedStudentIds.map((studentId) => {
                const student = internalStudents.find(
                  (student) => student.id === studentId
                );
                return student ? (
                  <div key={studentId} className="selected-student-item">
                    <input
                      type="checkbox"
                      checked={selectedStudentIds.includes(studentId)}
                      onChange={() => handleStudentSelect(studentId)}
                    />
                    <label>{student.name}</label>
                  </div>
                ) : null;
              })}
            </div>
          )}
          <div className="action-button-container">
            <button
              className={`blue-action-button ${
                selectedStudentIds.length === 0 ? "disabled-button" : ""
              }`}
              disabled={selectedStudentIds.length === 0}
              onClick={handleShare}
            >
              Share Watchlist
            </button>
          </div>
        </div>
      </div>

      {/* SEN Share Modal */}
      {showShareModal && (
        <SENShareModal
          show={showShareModal}
          handleClose={() => setShowShareModal(false)}
          className={className}
          teacherId={teacherId}
          schoolId={schoolId}
          expandedViewData={{
            ...expandedViewData,
            students: internalStudents.filter((student) =>
              selectedStudentIds.includes(student.id)
            ), // Pass only the selected students
          }}
        />
      )}
    </>
  );
};

export default SENShareActionCard;